import React from 'react';

import Button from '../Button';

const FormButton = ({ children, type="submit", ...attrs }) => (
  <Button {...attrs} type={type}>
    {children}
  </Button>
);

export default FormButton;
